<!-- Fees modal -->
<div bsModal #feesModal="bs-modal" [config]="modalConfig" class="modal fade" id="FeesModal" tabindex="-1" role="dialog" *ngIf="moduleType === 1 || moduleType == 3">
  <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Fees</h5>
        <button type="button" class="close" aria-label="Close" (click)="cancelFees(); closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mx-0 justify-content-end sameWidthBtn">
          <button type="button" *ngIf="moduleType == 3" class="btn btn-primary" (click)="addFees()" permissionHandler
            [functId]="68" [elementType]="eNumElementTypes.BUTTON" [action]="eNumActionTypes.EDIT">Add</button>
          <button type="button" *ngIf="moduleType == 1" class="btn btn-primary" (click)="addFees()" permissionHandler
            [functId]="95" [elementType]="eNumElementTypes.BUTTON" [action]="eNumActionTypes.CREATE">Add</button>
        </div>
<app-fee-list 
[title]="''" [fees]="newFees" [moduleType]="moduleType" [readonly]="false" [reasonRequired]="reasonRequired" [FeesEditRight]="FeesEditRight"
  [manualFeesAndCharges]="manualFeesAndCharges" [eNumActionTypes]="eNumActionTypes" [eNumElementTypes]="eNumElementTypes" [disableOption]="disableOption.bind(this)"
  [disableStopDates]="disableStopDates.bind(this)" [isReasonAdded]="isReasonAdded.bind(this)" [onLoadEffectiveDate]="onLoadEffectiveDate.bind(this)" [onLoadStopDate]="onLoadStopDate.bind(this)"
  (feesSelectionChanged)="checkFeesCharges($event.event, $event.feesAndChargesId, $event.item)" (feeChargeChanged)="feeschargesChanged($event.event, $event.item)" (feeChanged)="feesChanged($event.event, $event.feesAndChargesId, $event.item)"
(effectiveDateChanged)="effectiveDateChange($event.event, $event.feesAndChargesId, $event.item)" (stopDateChanged)="StopDateChange($event.event, $event.feesAndChargesId, $event.item)"
(notesChanged)="onNotesEntered($event.event, $event.feesAndChargesId, $event.item)">
</app-fee-list>
    <div class="mt-4" *ngIf="moduleType !== 3">
        <h5 class="edit_container_title">Fees Dues</h5>
      <div class="row mx-0 mt-2">
    <div class="scroll_outer NoSidePadding d-inline-block">
      <div class="scroll_inner fees_scroll_inner">
        <div class="borderd_table d-inline-block">
          <table class="table table-hover table-striped mb-0 feestable w-auto">
            <colgroup>
              <col style="width: 5%;">
              <col style="width: 10%;">
              <col style="width: 8%;">
              <col style="width: 13%;">
              <col style="width: 13%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Fees</th>
                <th scope="col" class="text-center">Due</th>
                <th scope="col" class="text-center">From Date</th>
                <th scope="col" class="text-center">To Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of duesFeesList">
                <td class="align-middle text-center">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" permissionHandler [moduleId]="11" [functId]="95"
                      [elementType]="eNumElementTypes.INPUT" [action]="eNumActionTypes.CREATE"
                      [disabled]="true"
                      [(ngModel)]="item.selected">
                    <span></span>
                  </label>
                </td>
                <td class="align-middle" *ngIf="item.FeesandChargesId !== 0 && item.ApplyManually === false">
                  {{item.Name}}</td>
                <td class=" align-middle text-center">{{item.Amount | currency}}</td>
                <td class="align-middle text-center">{{ item.EffectiveDate | date:'MM/dd/yyyy' }}</td>
                <td class="align-middle text-center">{{ item.PeriodToDate | date:'MM/dd/yyyy' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </div>
<app-fee-list *ngIf="moduleType !== 3"
  [title]="'Future Effective/Recurring Fees'" [fees]="futureFees" [moduleType]="moduleType" [readonly]="true" [reasonRequired]="reasonRequired"
  [FeesEditRight]="false" [manualFeesAndCharges]="manualFeesAndCharges" [eNumActionTypes]="eNumActionTypes" [eNumElementTypes]="eNumElementTypes"
 [disableStopDates]="disableStopDates.bind(this)" [isReasonAdded]="isReasonAdded.bind(this)" [onLoadEffectiveDate]="onLoadEffectiveDate.bind(this)"
[onLoadStopDate]="onLoadStopDate.bind(this)" (feesSelectionChanged)="checkFeesCharges($event.event, $event.feesAndChargesId, $event.item)"
(feeChargeChanged)="feeschargesChanged($event.event, $event.item)" (feeChanged)="feesChanged($event.event, $event.feesAndChargesId, $event.item)" (effectiveDateChanged)="effectiveDateChange($event.event, $event.feesAndChargesId, $event.item)"
(stopDateChanged)="StopDateChange($event.event, $event.feesAndChargesId, $event.item)" (notesChanged)="onNotesEntered($event.event, $event.feesAndChargesId, $event.item)">
</app-fee-list>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3"
          (click)="cancelFees(); closeModal()">Cancel</button>
        <div id="res_butt">
          <div class="button_tooltip">
            <button type="button" class="btn btn-primary"
              [disabled]="checkFeesChargesDisable() || disableForNoReason()||disableForNoEffectiveDate()|| disableForNoStopDate()"
              (click)="saveFeesAndCharges(); closeModal()">Save</button>
            <div class="button_tooltip_modal" *ngIf="disableForNoReason()">
              <p class="mb-0">Please enter the reason!</p>
              <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
            </div>
            <div class="button_tooltip_modal" *ngIf="disableForNoEffectiveDate()">
              <p class="mb-0">Please enter the Effective Date!</p>
              <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
            </div>
            <div class="button_tooltip_modal" *ngIf="disableForNoStopDate()">
  <p class="mb-0">Please enter the Stop Date!</p>
  <i class="fa fa-caret-down butt_downIcon" aria-hidden="true"></i>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Fees modal end //-->

<div *ngIf="moduleType == 2">
  <div class="row mx-0 justify-content-end sameWidthBtn">
    <button type="button" class="btn btn-primary" (click)="addFees()" permissionHandler [moduleId]="11" [functId]="95"
      [elementType]="eNumElementTypes.BUTTON" [action]="eNumActionTypes.CREATE">Add</button>
  </div>
<app-fee-list 
[title]="''" [fees]="newFees" [moduleType]="moduleType" [readonly]="false" [reasonRequired]="reasonRequired" [FeesEditRight]="FeesEditRight"
  [manualFeesAndCharges]="manualFeesAndCharges" [eNumActionTypes]="eNumActionTypes" [eNumElementTypes]="eNumElementTypes" [disableOption]="disableOption.bind(this)"
  [disableStopDates]="disableStopDates.bind(this)" [isReasonAdded]="isReasonAdded.bind(this)" [onLoadEffectiveDate]="onLoadEffectiveDate.bind(this)" [onLoadStopDate]="onLoadStopDate.bind(this)"
  (feesSelectionChanged)="checkFeesCharges($event.event, $event.feesAndChargesId, $event.item)" (feeChargeChanged)="feeschargesChanged($event.event, $event.item)"  (feeChanged)="feesChanged($event.event, $event.feesAndChargesId, $event.item)"
(effectiveDateChanged)="effectiveDateChange($event.event, $event.feesAndChargesId, $event.item)" (stopDateChanged)="StopDateChange($event.event, $event.feesAndChargesId, $event.item)"
(notesChanged)="onNotesEntered($event.event, $event.feesAndChargesId, $event.item)">
</app-fee-list>
    <div class="mt-4" >
        <h5 class="edit_container_title ">Fees Dues</h5>
      <div class="row mx-0 mt-2">
    <div class="scroll_outer NoSidePadding d-inline-block">
      <div class="scroll_inner fees_scroll_inner">
        <div class="borderd_table d-inline-block">
          <table class="table table-hover table-striped mb-0 feestable w-auto">
            <colgroup>
              <col style="width: 5%;">
              <col style="width: 10%;">
              <col style="width: 8%;">
              <col style="width: 13%;">
              <col style="width: 13%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Fees</th>
                <th scope="col" class="text-center">Due</th>
                <th scope="col" class="text-center">From Date</th>
                <th scope="col" class="text-center">To Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of duesFeesList">
                <td class="align-middle text-center">
                  <label class="pure-material-checkbox ">
                    <input type="checkbox" permissionHandler [moduleId]="11" [functId]="95"
                      [elementType]="eNumElementTypes.INPUT" [action]="eNumActionTypes.CREATE"
                      [disabled]="true"
                      [(ngModel)]="item.selected">
                    <span></span>
                  </label>
                </td>
                <td class="align-middle" *ngIf="item.FeesandChargesId !== 0 && item.ApplyManually === false">
                  {{item.Name}}</td>
                <td class=" align-middle text-center">{{item.Amount | currency}}</td>
                <td class="align-middle text-center">{{ item.EffectiveDate | date:'MM/dd/yyyy' }}</td>
                <td class="align-middle text-center">{{ item.PeriodToDate | date:'MM/dd/yyyy' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </div>
  <app-fee-list
  [title]="'Future Effective/Recurring Fees'" [fees]="futureFees" [moduleType]="moduleType" [readonly]="true" [reasonRequired]="reasonRequired"
  [FeesEditRight]="false" [manualFeesAndCharges]="manualFeesAndCharges" [eNumActionTypes]="eNumActionTypes" [eNumElementTypes]="eNumElementTypes"
 [disableStopDates]="disableStopDates.bind(this)" [isReasonAdded]="isReasonAdded.bind(this)" [onLoadEffectiveDate]="onLoadEffectiveDate.bind(this)"
[onLoadStopDate]="onLoadStopDate.bind(this)" (feesSelectionChanged)="checkFeesCharges($event.event, $event.feesAndChargesId, $event.item)"
(feeChargeChanged)="feeschargesChanged($event.event, $event.item)"  (feeChanged)="feesChanged($event.event, $event.feesAndChargesId, $event.item)" (effectiveDateChanged)="effectiveDateChange($event.event, $event.feesAndChargesId, $event.item)"
(stopDateChanged)="StopDateChange($event.event, $event.feesAndChargesId, $event.item)" (notesChanged)="onNotesEntered($event.event, $event.feesAndChargesId, $event.item)">
</app-fee-list>
</div>
